import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initAnalytics } from './utils/analytics'
// Captura o convite de instalação do app (beforeinstallprompt) desde o início, antes das páginas carregarem.
import '@/hooks/useInstalarApp';

initAnalytics()

// Teste de fumaça de navegação da Auditoria (somente em desenvolvimento).
// Verifica o contrato das 4 abas × rotas e expõe `__smokeAuditoria()` no console.
if (import.meta.env.DEV) {
  void import('./smoke/navegacaoAuditoria').then((m) => m.registrarSmokeNavegacaoAuditoria())
  // Smoke do CONTRATO DE CONSUMO da Auditoria: mapa ⇄ catálogo das 53 rotas,
  // `null` preservado (sem 0 inventado) e inventário D2 travado.
  // Verifica o que o CONTRATO_API_AUDITORIA.md promete. `__smokeContratoConsumo()` no console.
  void import('./smoke/contratoConsumoAuditoria').then((m) => m.registrarSmokeContratoConsumo())
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
